/* eslint-disable import/no-anonymous-default-export */
export default {
	banner: {
		wave: {
			yellow: '#f7a600',
		},
	},
};
